/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_PasteInputs */

const en_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const fr_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller`)
};

const de_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste`)
};

const it_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impasto`)
};

const ru_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить`)
};

const es_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta`)
};

const zh_cn2_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴`)
};

const ja_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペースト`)
};

const hi_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट करें`)
};

const pt_pt2_shortcut_keys_name_paste = /** @type {(inputs: Shortcut_Keys_Name_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar`)
};

/**
* | output |
* | --- |
* | "Paste" |
*
* @param {Shortcut_Keys_Name_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_paste = /** @type {((inputs?: Shortcut_Keys_Name_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_paste(inputs)
	if (locale === "de") return de_shortcut_keys_name_paste(inputs)
	if (locale === "it") return it_shortcut_keys_name_paste(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_paste(inputs)
	if (locale === "es") return es_shortcut_keys_name_paste(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_paste(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_paste(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_paste(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_paste(inputs)
	return en_shortcut_keys_name_paste(inputs)
});